
import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import Spinner from '../Spinner/Spinner';

const Feedback = () =>{
    const [isLoading, setIsLoading] = useState(false);
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Message, setMessage] = useState('');
    const [ShowAlert, setShowAlert] = useState(false);

    const isValid = () => {
        
        var result: Boolean = true;

        if (!Name) {
            result = false;
        }

        if (!Message) {
            result = false;
        }

        return result;
    }

    const SendMail = () => {
        
        if (!isValid()) {
            alert('Please fill all required fields');
            return false;
        }



        setIsLoading(true);
        const data = {
            Name: Name,
            Email: Email,
            Message: Message,
        }
        
        apiPost("api/Email/Feedback", data).then((res: any) => {
            
            setName('');
            setEmail('');
            setMessage('');

            setIsLoading(false);
            setShowAlert(true);
        });
    }



    return(<>
    
    {(isLoading && <Spinner></Spinner>)}

    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/feedback-banner.jpg" alt="MeriPustak-About"/>
       
    </div>

 {/* <!-- Contact Section Start --> */}
    <section className="contact-section fix section-padding">
        <div className="container">
            <div className="contact-wrapper">
                <div className="row g-4">
                    <div className="col-lg-6">
                        <div className="contact-left-items">
                          <p>MeriPustak strives to bring the best books, delivery and services for professionals and book readers in India through its best offerings and robust services across the country. MeriPustak welcomes your feedback on its Services which gives us an opportunity to improve and helping us understand what we do well and what improvements we need to implement to provide you pleasant online experience.</p>
                           
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="contact-content">
                            <h2>Feedback </h2>
                           
                            <form action="#" id="contact-form" method="POST" className="contact-form-items">
                                <div className="row g-4">
								
                                    <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                                        <div className="form-clt">
                                            <span>Your name*</span>
                                            <input type="text"  value={Name} onChange={(e: any) => { setName(e.target.value) }}  name="name" id="name" placeholder=""/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                        <div className="form-clt">
                                            <span>Your Email*</span>
                                            <input type="text" value={Email} onChange={(e: any) => { setEmail(e.target.value) }}  name="email" id="email" placeholder=""/>
                                        </div>
                                    </div>
									
									
                                    <div className="col-lg-12 wow fadeInUp" data-wow-delay=".7s">
                                        <div className="form-clt">
                                            <span>Share your Feedback here*</span>
                                            <textarea value={Message} onChange={(e: any) => { setMessage(e.target.value) }}  name="message" id="message"
                                                placeholder=""></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 wow fadeInUp" data-wow-delay=".9s">
                                        <button type="button" onClick={SendMail}  className="theme-btn">
                                            Send Message <i className="fa-solid fa-arrow-right-long"></i>
                                        </button>
                                    </div>
                                    <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                            {ShowAlert && <div className="alert alert-success">
                                                Thanks for contacting us. We will get back to you at the earliest.
                                            </div>}
                                        </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    </>);
}

export default Feedback;